import React, { useEffect, useState } from "react";
import axios from "axios";
import "./WebinarPage.css";

// 🔥 NEXT TUE / THU 5PM
const getNextWebinarDate = () => {
  const now = new Date();

  const nextDate = new Date(now);

  // Thursday = 4
  const daysUntilThursday = (4 - nextDate.getDay() + 7) % 7;

  nextDate.setDate(nextDate.getDate() + daysUntilThursday);

  // 5:00 PM
  nextDate.setHours(17, 0, 0, 0);

  // If today is Thursday after 5 PM, schedule next Thursday
  if (nextDate <= now) {
    nextDate.setDate(nextDate.getDate() + 7);
  }

  return nextDate;
};

const WebinarPage = () => {
  useEffect(() => {
  const navbar = document.querySelector("header, .navbar");
  const footer = document.querySelector("footer");

 
  if (navbar) navbar.style.display = "none";
  if (footer) footer.style.display = "none";

  return () => {
    // 🔥 மீண்டும் restore
    if (navbar) navbar.style.display = "";
    if (footer) footer.style.display = "";
  };
}, []);
useEffect(() => {
  const hideWidget = () => {

    // 🔥 ElevenLabs widget remove
    document.querySelectorAll("elevenlabs-convai").forEach(el => el.remove());

    // 🔥 also remove injected containers
    document.querySelectorAll("iframe, [class*='convai'], [id*='convai']")
      .forEach(el => el.remove());
  };

  // run immediately
  hideWidget();

  // 🔥 keep checking (important)
  const interval = setInterval(hideWidget, 500);

  return () => clearInterval(interval);
}, []);

  const [targetDate, setTargetDate] = useState(getNextWebinarDate());
  const [countdown, setCountdown] = useState("");
  const [weekCount, setWeekCount] = useState(0);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }, []);
  // 🔥 countdown
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        setTargetDate(getNextWebinarDate());
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      setCountdown(`${d}d ${h}h ${m}m ${s}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  // 🔥 weekly count
  useEffect(() => {

  const fetchCount = async () => {
    try {
      const res = await axios.get("/api/webinar-users/week-count");
      setWeekCount(res.data.count);
    } catch (err) {
      console.error(err);
    }
  };

  // first load
  fetchCount();

  // 🔥 auto update every 5 sec
  const interval = setInterval(fetchCount, 5000);

  return () => clearInterval(interval);

}, []);
  // 🔥 form change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // 🔥 submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("/api/webinar-register", {
        ...formData,
        webinarDate: targetDate
      });

      alert("✅ Registered Successfully!");
      setFormData({ name: "", email: "", phone: "" });

    } catch (error) {
      alert(error.response?.data?.error || "Error");
    }
  };

  return (
    <div className="page">

      <div className="wrapper">

        {/* LEFT SIDE */}
        <div className="left-card">

          <span className="badge">
            Free Live Webinar for Serious Cricketers
          </span>

          <h1>
            Why Genetics Isn’t Your Real Problem
          </h1>

          <p className="sub">
            (The 3 Trainable Skills That Separate National Team Players From Everyone Else)
          </p>

          <p className="desc">
            If you’ve ever felt like you’re just a fraction late on the ball,
            this session is for you. You’ll understand why some players always
            seem to have more time — and how reaction speed, not genetics,
            is often the real difference.
          </p>

          <div className="points">
            <p>✔️ Why you feel late on fast bowling even when your technique looks fine</p>
            <p>✔️ The exact reaction speed gap between most players and elite performers</p>
            <p>✔️ What you can realistically improve in the next 12 weeks with the right training</p>
          </div>

          <p className="bottom-text">
            Built from real athlete testing and performance data.
          </p>

        </div>

        {/* RIGHT SIDE */}
        <div className="right-card">

          <div className="top-info">
            📅 {targetDate.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric"
            })} | ⏰ 5:00 PM IST
          </div>

          <div className="week">
            🔥 {weekCount} athletes registered this week
          </div>

          {/* 🔥 LIVE / COUNTDOWN SWITCH */}
          <div className="live-box">
            {countdown === "0d 0h 0m 0s" ? (
              <>
                <small>STARTED</small>
                <h2>Live now</h2>
                <p>We start live. No replay guaranteed.</p>
              </>
            ) : (
              <>
                <small>STARTS IN</small>
                <h2>{countdown}</h2>
              </>
            )}
          </div>

          <h3 className="form-title">Save My Spot</h3>
          <p className="form-sub">Takes 10 seconds. No spam.</p>

          <form onSubmit={handleSubmit}>

            <input
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              name="phone"
              placeholder="Enter your phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <button>Join the Free Session</button>

          </form>

          <p className="note">
            You’ll receive the joining details by email.
          </p>

        </div>

      </div>

    </div>
  );
};

export default WebinarPage;